module.exports = __webpack_public_path__ + "img/38957-008.361afdb8.jpg";